jQuery (function () {
	jQuery ('#toggle-mobile-nav').on ('click', function () {
		
		if (jQuery (this).hasClass ('close-icon')) {
			jQuery (this).removeClass ('close-icon');	
		} else {
			jQuery (this).addClass ('close-icon');	
		}
		
	});
});